// @ts-nocheck
import React from 'react';

/**
 * Card — paper surface with soft border + shadow. Pass `padded={false}` for
 * tables or other contents that own their padding. `interactive` adds a hover
 * border emphasis.
 */
const Card = React.forwardRef(({
  className = '',
  padded = true,
  interactive = false,
  as: Tag = 'div',
  children,
  ...rest
}, ref) => (
  <Tag
    ref={ref}
    className={[
      'mov-card-surface',
      padded ? 'p-5' : '',
      interactive ? 'transition-[border-color,box-shadow] duration-150 hover:border-mov-line-strong' : '',
      className,
    ].join(' ')}
    {...rest}
  >
    {children}
  </Tag>
));
Card.displayName = 'Card';

export const CardHead = ({ title, sub, action, className = '' }) => (
  <div className={`flex items-center justify-between gap-3 mb-3.5 ${className}`}>
    <div className="min-w-0">
      {title && <h3 className="m-0 text-[14.5px] font-semibold tracking-[-0.005em]">{title}</h3>}
      {sub && <div className="text-[12px] text-mov-ink-mute mt-0.5">{sub}</div>}
    </div>
    {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
  </div>
);

export default Card;
